import React, { createContext, useEffect, useState, useContext } from 'react';
const ModalContext = createContext({
    cue: [],
    isActive: false,
    add: (updateInstanceIdCallback) => {
        updateInstanceIdCallback(0);
    },
    remove: () => { },
});
const ModalCue = ({ children }) => {
    const [cue, setCue] = useState([]);
    useEffect(() => {
        const modalsOpenedWithContext = cue.filter((modal) => modal.isOpenWithContext);
        const lastModal = cue.slice(-1)[0];
        const shouldUpdateCue = cue.length &&
            (!modalsOpenedWithContext.length ||
                modalsOpenedWithContext[0].instanceId !== lastModal.instanceId);
        if (shouldUpdateCue) {
            const newCue = cue.map((item, itemIndex) => {
                return Object.assign(Object.assign({}, item), {
                    isOpenWithContext: itemIndex === cue.length - 1,
                    isParent: cue.length > 1 && itemIndex < cue.length - 1,
                    isChild: cue.length > 1 && itemIndex >= 1,
                });
            });
            setCue(newCue);
        }
    }, [cue]);
    const add = (updateInstanceIdCallback) => {
        setCue((oldCue) => {
            const newInstanceId = oldCue.length + 1;
            updateInstanceIdCallback(newInstanceId);
            return [
                ...oldCue,
                {
                    instanceId: newInstanceId,
                    isParent: false,
                    isChild: newInstanceId > 1,
                    isOpen: true,
                    isOpenWithContext: true,
                },
            ];
        });
    };
    const remove = (instanceId) => {
        const newCue = cue.filter((item) => item.instanceId !== instanceId);
        setCue(newCue);
    };
    return (React.createElement(ModalContext.Provider, { value: { cue, isActive: true, add, remove } }, children));
};
const useModalCue = () => {
    const { cue, isActive, add, remove } = useContext(ModalContext);
    const [instanceId, setInstanceId] = useState(0);
    const [isBaseOpen, setBaseOpen] = useState(false);
    const [cueHasItems, setCueHasItems] = useState(false);
    const [cueItem, setCueItem] = useState(null);
    const updateBaseOpen = (isOpen) => {
        setBaseOpen(isOpen);
    };
    const updateInstanceId = (value) => {
        setInstanceId(value);
    };
    useEffect(() => {
        if (isActive && isBaseOpen && !instanceId) {
            add(updateInstanceId);
        }
        else if (isActive && !isBaseOpen && instanceId) {
            remove(instanceId);
            setInstanceId(0);
            setCueItem(null);
        }
    }, [isBaseOpen, isActive, instanceId]);
    useEffect(() => {
        if (isActive && cue.length) {
            setCueHasItems(true);
            if (instanceId) {
                const newCueItem = cue.find((item) => item.instanceId === instanceId);
                if (newCueItem) {
                    setCueItem(newCueItem);
                }
            }
        }
        else {
            setCueHasItems(false);
        }
    }, [isActive, cue, instanceId]);
    return { cueItem, cueHasItems, updateBaseOpen };
};
export { ModalCue as default, useModalCue };
//# sourceMappingURL=ModalCue.js.map